<div class="modal-body">
    <img src="assets/img/close.png" class="close" (click)="close()" />

    <div class="body-wrapper"
        [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
        <img src="assets/img/dialog-error.png" class="icon-confirmation" />
        <h1
            [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
            {{ "confirmation_consent_title" | translate }}
        </h1>
        <p *ngIf="notConsentChoosen.length">
            {{ "confirmation_consent_content" | translate }} <b>{{ notConsentList }}</b>
        </p>
        <!-- <div class="box-info">
            <img src="assets/img/alert-icon-black.png" class="icon-info" />
            {{ "confirmation_sure" | translate }}
        </div> -->

    </div>
    <div class="row">
        <div class="col-12">
            <button class="btn-agree"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }"
                type="button" (click)="close()">
                {{ "check_again" | translate}}
            </button>
        </div>
        <div class="col-12">
            <button class="btn-disagree"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'bg-orange' : platform === 'tri' }"
                type="button" (click)="save(0)">
                {{ "yes_confirm" | translate}}
            </button>
        </div>
    </div>
</div>